export const PENDING_WEB_PAYMENT_STORAGE_KEY = 'paywall_v8_pending_payment';

export function clearPendingWebPayment(): void {
  try {
    window.sessionStorage.removeItem(PENDING_WEB_PAYMENT_STORAGE_KEY);
  }
  catch {
    // Storage can be unavailable in hardened browser modes.
  }
}
